import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './landing-page.magic.css.js';
import script from './landing-page.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"part":"wrapper","data-v-test-id":"landing-details-container"}},[(_vm.isLoading)?_c('magic-ui-loading'):(_vm.landingPage)?_c('div',{staticClass:"content landing-page-content",attrs:{"part":"content landing-page-content"}},[(_vm.background)?_c('div',{staticClass:"background",style:({ backgroundImage: ("url(" + _vm.background + ")") }),attrs:{"part":"background"}}):_vm._e(),_vm._v(" "),_c('magic-ui-text',{staticClass:"title",attrs:{"tag":"h1","part":"title","data-v-test-id":"landing-title","content":_vm.landingPage.title}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"body",attrs:{"is-markdown":"","landing-page-text":"","part":"body","data-v-test-id":"landing-description","content":_vm.landingPage.markdown}})],1):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-84fc63c8_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-84fc63c8";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
